export default class Visualizer {
  series = [];
  charts = [];
  dataset0;
  dataset1;
  dataset2;

  RANGES_DEFAULT = [];
  CHARTS_DEFAULT = [];

  constructor(params) {
    this.charts = params || [];

    this.setDefaults();

    return {
      charts: this.charts.map(x => Object.assign(this.CHARTS_DEFAULT.find(y => y.type == x.type), x)),
      setup: {
        baseURL: "https://data.populate.tools/visualizador/",
        headers: { Authorization: "Bearer WxVwwI-uTEVzvP6RF8FiFg" }
        // timeout: 10000
      },
      ranges: dataset => {
        if (!dataset) {
          return this.RANGES_DEFAULT;
        }

        const { ranges } = this.series.find(d => d.id === dataset);
        return ranges;
      },
      endpoints: {
        series: {
          build: () => ["datasets.json", "collections/c-categorias-presupuestos-municipales/items.json"],
          parse: data => {
            const [datasets, collections] = data;

            // Handle user selections
            this.dataset2 = collections;

            return Object.values(datasets)
              .reduce((acc, item) => {
                const match = this.series.find(f => f.id === item.id);
                if (match) {
                  // Series MUST HAVE { id, name }, optional { group }
                  acc.push({ id: item.id, name: item.name, group: match.group || "Otros" });
                }

                return acc;
              }, [])
              .sort((a, b) => this.series.findIndex(d => d.id === a.id) - this.series.findIndex(d => d.id === b.id));
            // FIXME: Don't merge budgets, concat disabled
            // .concat(collections.map(d => ({ id: parseInt(d.code), name: d.name })));;
          }
        },
        data: {
          build: params => {
            const req = [];

            if (params.varX) {
              if (Number.isInteger(params.varX)) {
                req.push(this.helperCollectionQuery(params.varX, params.range));
              } else {
                req.push(this.helperDatasetQuery(params.varX, params.range));
              }
            }
            if (params.varY) {
              req.push(this.helperDatasetQuery(params.varY, params.range));
            }

            // Handle user selections
            this.dataset0 = params.varX;
            this.dataset1 = params.varY;

            return req;
          },
          parse: data => {
            const arrMerged = [];
            let [arr0 = [], arr1 = []] = data;

            // Returns only if BOTH results have data
            if (arr0.length && arr1.length) {
              // Budgets
              if (arr0.some(d => d.hasOwnProperty("organization_id"))) {
                // TODO: Create helper function as helperMergeByLocationId
                arr0.forEach(d => {
                  const itemMerged = {};
                  const matchedItem = arr1.find(g => parseInt(g.location_id) === parseInt(d.ine_code));
                  if (matchedItem) {
                    itemMerged.value0 = parseInt(d.amount);
                    itemMerged.value1 = parseFloat(
                      matchedItem.hasOwnProperty("divided_by_value")
                        ? matchedItem.divided_by_value * (matchedItem.ratioFactor || 1)
                        : matchedItem.value
                    );
                    itemMerged.location_id = parseInt(d.ine_code);
                    itemMerged.location_desc = matchedItem.municipality_name;
                    itemMerged.province_id = parseInt(d.province_id);
                    itemMerged.province_desc = matchedItem.province_name;

                    arrMerged.push(itemMerged);
                  }
                });
              } else {
                arrMerged.push(...this.helperMergeByLocationId(arr0, arr1));
                // save memory
                arr0 = null;
                arr1 = null;
              }
            }

            return arrMerged;
          }
        }
      }
    };
  }

  setDefaults = () => {
    this.series = [
      {
        id: "ds-contratos-municipio",
        freq: "month",
        name: "Número de contratos",
        units: "contratos / 1.000 hab.",
        ranges: [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
        ratio: "ds-poblacion-municipal",
        ratioFactor: 1000,
        group: "Empleo"
      },
      {
        id: "ds-poblacion-activa-municipal",
        freq: "month",
        name: "Población activa",
        units: "habitantes entre 16 y 65 años",
        ranges: [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
        group: "Empleo"
      },
      {
        id: "ds-poblacion-municipal",
        name: "Población",
        units: "habitantes",
        ranges: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018],
        scale: "log",
        group: "Demografía"
      },
      {
        id: "ds-autonomos-municipio",
        name: "Autónomos",
        units: "autónomos / 1.000 hab.",
        freq: "month",
        ranges: [2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
        ratio: "ds-poblacion-municipal",
        ratioFactor: 1000,
        group: "Empleo"
      },
      {
        id: "ds-defunciones-municipal",
        name: "Defunciones",
        units: "defunciones / 1.000 hab.",
        ranges: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017],
        ratio: "ds-poblacion-municipal",
        ratioFactor: 1000,
        group: "Demografía"
      },
      {
        id: "ds-empresas-municipio",
        name: "Empresas",
        units: "empresas / 1.000 hab.",
        ranges: [2014],
        ratio: "ds-poblacion-municipal",
        ratioFactor: 1000,
        group: "Economía"
      },
      {
        id: "ds-deuda-municipal",
        name: "Deuda",
        units: "€ / hab.",
        ranges: [2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018],
        ratio: "ds-poblacion-municipal",
        group: "Presupuestos"
      },
      {
        id: "ds-afiliados-ss-municipio",
        freq: "month",
        name: "Afiliados a la Seg. Social",
        units: "afiliados / 1.000 hab.",
        ranges: [2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
        ratio: "ds-poblacion-municipal",
        ratioFactor: 1000,
        group: "Empleo"
      },
      {
        id: "ds-personas-paradas-municipio",
        freq: "month",
        name: "Personas paradas",
        units: "desempleados / 1.000 hab.",
        ranges: [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
        ratio: "ds-poblacion-municipal",
        ratioFactor: 1000,
        group: "Empleo"
      },
      {
        id: "ds-tasa-paro-municipal",
        freq: "month",
        name: "Tasa de paro",
        units: "",
        ranges: [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
        group: "Empleo"
      },
      {
        id: "ds-renta-bruta-media-municipal",
        name: "Renta bruta media",
        units: "€",
        ranges: [2014, 2016],
        group: "Economía"
      },
      {
        id: "ds-nacimientos-municipal",
        name: "Nacimientos",
        units: "nacimientos / 1.000 hab.",
        ranges: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017],
        ratio: "ds-poblacion-municipal",
        ratioFactor: 1000,
        group: "Demografía"
      },
      {
        id: "ds-viviendas-municipales-familiares",
        name: "Viviendas",
        units: "viviendas / 1.000 hab.",
        ranges: [2011],
        ratio: "ds-poblacion-municipal",
        ratioFactor: 1000,
        group: "Economía"
      }
    ];

    this.RANGES_DEFAULT = [
      2000,
      2001,
      2002,
      2003,
      2004,
      2005,
      2006,
      2007,
      2008,
      2009,
      2010,
      2011,
      2012,
      2013,
      2014,
      2015,
      2016,
      2017,
      2018
    ];

    this.CHARTS_DEFAULT = [
      {
        type: "Dispersion",
        xAxisProp: "value0",
        yAxisProp: "value1",
        aggregationProp: "province_desc",
        btnPlaceholder: "Selecciona provincia",
        palette: ["#F8B419", "#b82e2e", "#66aa00", "#dd4477", "#636363", "#273F8E", "#e6550d", "#990099", "#06670C", "#2A8998"],
        tooltip: this.tooltipCommon,
        title: "Deuda viva por municipio",
        source: "Fuente: Populate Data(2018)",
        xScaleFunction: (dataset, d3) => {
          if (!dataset) return undefined;

          const { scale } = this.series.find(s => s.id === dataset);
          if (!scale) return undefined;

          return this.getScale(scale, d3);
        },
        yScaleFunction: (dataset, d3) => {
          if (!dataset) return undefined;

          const { scale } = this.series.find(s => s.id === dataset);
          if (!scale) return undefined;

          return this.getScale(scale, d3);
        }
      },
      {
        type: "Espectro",
        xAxisProp: "value0",
        yAxisProp: "value1",
        aggregationProp: "province_desc",
        legendLabels: ["Más", "Menos"],
        averageLabel: "Media",
        medianLabel: "Mediana",
        sampleSize: 3,
        baseDataset: "ds-poblacion-municipal",
        tooltip: this.tooltipCommon
      }
    ];
  };

  getScale(key, d3) {
    const scales = {
      linear: d3.scaleLinear(),
      log: d3.scaleLog(),
      pow: d3.scalePow()
    };

    if (scales.hasOwnProperty(key)) {
      return scales[key];
    } else {
      return scales[0];
    }
  }

  tooltipCommon = d => {
    const { units: units0, name: name0 } = this.series.find(d => d.id === this.dataset0);
    const { units: units1, name: name1 } = this.series.find(d => d.id === this.dataset1);

    return `<div style="padding: 1rem;"><div style="margin: 0 0 8px"><strong>${d.location_desc}</strong> (${
      d.province_desc
    })</div><div>${name0}: ${d.value0.toLocaleString()} ${units0}</div><div>${name1}: ${d.value1.toLocaleString()} ${units1}</div></div>`;
  };

  helperMergeByLocationId = (arr0, arr1) => {
    const arrMerged = [];
    const arr0__ = arr0.length;

    for (let index = 0; index < arr0__; index++) {
      const element = arr0[index];
      const locId = parseInt(element.location_id);

      if (locId !== undefined) {
        const itemMerged = {};
        const matchedItem = arr1.find(g => !g.matched && parseInt(g.location_id) === locId);

        if (matchedItem) {
          itemMerged.value0 = parseFloat(
            element.hasOwnProperty("divided_by_value") ? element.divided_by_value * (element.ratioFactor || 1) : element.value
          );
          itemMerged.value1 = parseFloat(
            matchedItem.hasOwnProperty("divided_by_value")
              ? matchedItem.divided_by_value * (matchedItem.ratioFactor || 1)
              : matchedItem.value
          );
          itemMerged.location_id = locId;
          itemMerged.location_desc = element.municipality_name;
          itemMerged.province_id = parseInt(element.province_id);
          itemMerged.province_desc = element.province_name;

          arrMerged.push(itemMerged);

          // Once matched, ignore it
          matchedItem.matched = true;
        }
      }
    }

    return arrMerged;
  };

  helperDatasetQuery = (param, range) => {
    const isMonthly = this.series.some(d => d.id === param && d.freq === "month");
    const seriesWithRatio = this.series.find(d => d.id === param && d.hasOwnProperty("ratio"));

    let ratioQuery = "";
    if (seriesWithRatio !== undefined) {
      ratioQuery = `&divided_by=${seriesWithRatio.ratio}`;
    }

    if (isMonthly) {
      range = new Date().getFullYear() === range ? `${range}-01` : `${range}-12`;
    }

    return `datasets/${param}.csv?filter_by_date=${range}&include=municipality,province&except_columns=municipality_slug,province_slug,municipality_lat,municipality_lon,province_lat,province_lon${ratioQuery}`;
  };

  helperCollectionQuery = (param, range) => {
    const { code, area, kind } = this.dataset2.find(d => d.code === param.toString());

    const dataset = area === "functional" ? "ds-presupuestos-municipales-funcional" : "ds-presupuestos-municipales-economica";
    const type = kind === "expense" ? "G" : "I";

    return `datasets/${dataset}.json?filter_by_year=${range}&filter_by_code=${code}&filter_by_kind=${type}`;
  };
}
